import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "engagement",
  listKey: "engagements",
  itemKey: "engagement",
  getAll: types.GET_ALL_ENGAGEMENTS,
  getAllResponse: types.GET_ALL_ENGAGEMENTS_RESPONSE,
  getByIdResponse: types.GET_ENGAGEMENT_BY_ID_RESPONSE,
});
